let accessTokenFun;

export const ExternalAuthContext = {
    getAccessTokenSilently: () => accessTokenFun,
    setAccessTokenSilently: (func) => { 
        accessTokenFun = func
    }
};